import { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import {
    Box,
    Container,
    Typography,
    Button,
    CircularProgress,
    Paper
} from '@mui/material';
import { CheckCircle } from '@mui/icons-material';

export const PaymentSuccessPage = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const [countdown, setCountdown] = useState(5);

    const subscriptionId = searchParams.get('subscription_id');
    const type = searchParams.get('type'); // 'subscription' o 'order'

    useEffect(() => {
        // Cuenta regresiva y redirección automática
        const timer = setInterval(() => {
            setCountdown(prev => {
                if (prev <= 1) {
                    clearInterval(timer);
                    navigate('/account');
                    return 0;
                }
                return prev - 1;
            });
        }, 1000);

        return () => clearInterval(timer);
    }, [navigate]);

    return (
        <Box
            sx={{
                minHeight: '100vh',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                bgcolor: 'background.default'
            }}
        >
            <Container maxWidth="sm">
                <Paper
                    elevation={3}
                    sx={{
                        p: 6,
                        textAlign: 'center',
                        borderRadius: 3,
                        border: '2px solid',
                        borderColor: 'success.main'
                    }}
                >
                    <CheckCircle
                        sx={{ fontSize: 80, color: 'success.main', mb: 2 }}
                    />

                    <Typography variant="h4" fontWeight="bold" gutterBottom>
                        ¡Pago exitoso!
                    </Typography>

                    <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
                        Tu suscripción ha sido activada correctamente. 
                        Ya puedes usar todas las funciones de tu nuevo plan.
                    </Typography>

                    {subscriptionId && (
                        <Paper
                            elevation={0}
                            sx={{ p: 2, bgcolor: 'action.hover', borderRadius: 1, mb: 3 }}
                        >
                            <Typography variant="caption" color="text.secondary">
                                ID de suscripción
                            </Typography>
                            <Typography variant="body2" fontWeight="600" sx={{ wordBreak: 'break-all' }}>
                                {subscriptionId}
                            </Typography>
                        </Paper>
                    )}

                    <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
                        Serás redirigido a tu cuenta en{' '}
                        <strong>{countdown}</strong> segundo{countdown !== 1 ? 's' : ''}...
                    </Typography>

                    <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center' }}>
                        <Button
                            variant="contained"
                            color="success"
                            size="large"
                            onClick={() => navigate('/account')}
                        >
                            Ir a Mi Cuenta
                        </Button>
                        <Button
                            variant="outlined"
                            size="large"
                            onClick={() => navigate('/')}
                        >
                            Ir al Inicio
                        </Button>
                    </Box>
                </Paper>
            </Container>
        </Box>
    );
};

export default PaymentSuccessPage;
